'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { Intercom, useIntercom } from '@/hooks/3dParty/intercom';
import { ErrorBlock } from './ErrorBlock';

interface INotFoundBlock {
  text: string;
  buttonText: string;
  contactUsText: string;
}

export const NotFoundBlock = ({
  text,
  buttonText,
  contactUsText,
}: INotFoundBlock) => {
  useEffect(() => {
    Sentry.withScope((scope) => {
      scope.setTags({
        category: 'notFound',
        pathToFile: 'src/components/internal/NotFound.tsx',
      });

      scope.setLevel('error');

      Sentry.captureMessage('Page not Found');
    });
  }, []);

  useIntercom();

  return (
    <ErrorBlock
      buttonText={buttonText}
      contactUsText={contactUsText}
      handleOpenSupport={Intercom.openChat}
      image="/common/notFoundImg.webp"
      logo
      showUrl
      text={text}
    />
  );
};
